import React, { useState } from 'react';
import { useForm } from '../context/FormContext';
import { isValidSSN, formatSSN } from '../utils/validation';

export default function Step04_SSN({ onNext, onBack }) {
  const { state, dispatch } = useForm();
  const [errs, setErrs] = useState({});
  const [showSSN, setShowSSN] = useState(false);

  const next = () => {
    const e = {};
    if (!isValidSSN(state.ssn)) e.ssn = 'SSN must be in format XXX-XX-XXXX';
    if (state.ssn !== state.ssnConfirm) e.ssnConfirm = 'Social Security Numbers do not match';
    if (Object.keys(e).length) { setErrs(e); return; }
    onNext();
  };

  return (
    <div className="step-card">
      <h2 className="step-title">Social Security Number</h2>
      <p className="step-subtitle">Your SSN is required for DOT compliance purposes. It will not be stored on this server.</p>
      <div className="field-group">
        <label className="field-label">Social Security Number <span className="required">*</span></label>
        <input
          className={`field-input ${errs.ssn ? 'error' : ''}`}
          type={showSSN ? 'text' : 'password'}
          value={state.ssn}
          onChange={e => {
            const formatted = formatSSN(e.target.value);
            dispatch({ type: 'SET_FIELD', key: 'ssn', value: formatted });
            setErrs(v => ({ ...v, ssn: '' }));
          }}
          placeholder="XXX-XX-XXXX"
          inputMode="numeric"
          maxLength={11}
        />
        {errs.ssn && <div className="field-error">{errs.ssn}</div>}
      </div>
      <div className="field-group">
        <label className="field-label">Confirm SSN <span className="required">*</span></label>
        <input
          className={`field-input ${errs.ssnConfirm ? 'error' : ''}`}
          type={showSSN ? 'text' : 'password'}
          value={state.ssnConfirm}
          onChange={e => {
            const formatted = formatSSN(e.target.value);
            dispatch({ type: 'SET_FIELD', key: 'ssnConfirm', value: formatted });
            setErrs(v => ({ ...v, ssnConfirm: '' }));
          }}
          placeholder="Re-enter SSN"
          inputMode="numeric"
          maxLength={11}
        />
        {errs.ssnConfirm && <div className="field-error">{errs.ssnConfirm}</div>}
      </div>
      <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, color: 'var(--text-light)', cursor: 'pointer', marginBottom: 20 }}>
        <input type="checkbox" checked={showSSN} onChange={e => setShowSSN(e.target.checked)} />
        Show SSN
      </label>
      <div className="wizard-nav" style={{ position: 'static', borderTop: 'none', padding: 0 }}>
        <button className="btn-back" onClick={onBack}>← Back</button>
        <button className="btn-next" onClick={next}>Next →</button>
      </div>
    </div>
  );
}
